import { EMPTY_STRING } from '@/data/constants/marketing';
import { useNewsLetterSubscription } from "@/data/Content/NewsLetterSubscription";
import { useLocalization } from "@/data/Localization";
import { useSettings } from '@/data/Settings';
import { ID } from '@/data/types/Basic';
import { REG_EX } from "@/utils/address";
import { useForm } from "@/utils/useForm";
import {
	Button,
	Checkbox,
	FormControlLabel,
	Grid,
	Stack,
	TextField,
	Typography,
} from '@mui/material';
import { ChangeEvent, FC, useMemo } from "react";
import { ContentRecommendation } from "../ContentRecommendation";
import { subscribeButtonSX, subscriptionEmailSX } from "./styles/newsLetterStyles";

export const NewsLetterSubscription: FC<{ id: ID }> = () => {
	const newsLetterNLS = useLocalization('NewsLetterSubscription');
	const { initSubscriptionValues, userSubscriptionSubmit, sendNewsLetterSubsc } = useNewsLetterSubscription();
	const {
		formRef,
		values: subscriptionValues, 
		handleInputChange,
		handleSubmit,
		error,
		setError,
	} = useForm(initSubscriptionValues);
	
	const { settings } = useSettings();
	
	 // Use useMemo to compute contact list IDs
	 const { gamingContactListId, babyPeuterContactListId } = useMemo(() => {
        const UserPreferencesForNewsLetterSubscription = settings.userData.UserPreferencesForNewsLetterSubscription;
        const UserPreferencesForNewsLetterSubscriptionArray = UserPreferencesForNewsLetterSubscription.split(',');

        let gamingId = '';
        let babyPeuterId = '';

        if (UserPreferencesForNewsLetterSubscriptionArray.length > 0) {
            const babyPeuter = UserPreferencesForNewsLetterSubscriptionArray[0];
            babyPeuterId = babyPeuter.split(':').at(1) ?? '';

            const gaming = UserPreferencesForNewsLetterSubscriptionArray[1];
            gamingId = gaming.split(':').at(1) ?? '';
        }

        return { gamingContactListId: gamingId, babyPeuterContactListId: babyPeuterId };
    }, [settings]);
	
	const handleChange = (e: ChangeEvent<HTMLInputElement>, contactListId: string) => {
		const emailIdEle = document.getElementById("emailIdField") as HTMLInputElement;
		if(emailIdEle.checkValidity()){
			if (subscriptionValues.emailId !== '') {
				sendNewsLetterSubsc(subscriptionValues.emailId, contactListId, e.target.checked);
			}
		}
			else{ setError && setError({"emailId":true});
	}
	}
	return (
		<Stack component="form" onSubmit={handleSubmit(userSubscriptionSubmit)} ref={formRef} noValidate >
			<Grid>
				<ContentRecommendation
					id={`newsLetterSubscription-espot-rv`}
					properties={{ emsName: 'newsLetterSubscription-espot-rv' }}
				/>
			</Grid>
			<Stack spacing={2} display={'flex'} flexDirection={'row'} sx={{paddingRight:'18px'}}>
				<Stack  sx={subscriptionEmailSX}>
					<TextField
						id="emailIdField"
						fullWidth
						margin="normal"
						required
						name="emailId"
						label={newsLetterNLS.Labels.EmailId.t()}
						autoFocus
						value={subscriptionValues.emailId}
						onChange={handleInputChange}
						inputProps={{
							maxLength: 100,
							type: 'email',
							placeholder: newsLetterNLS.EmailPlaceholder.t(),
							pattern: REG_EX.EMAIL.source,
						}}
						error={error.emailId}
						helperText={error.emailId ? newsLetterNLS.Msgs.InvalidEmail.t() : EMPTY_STRING} />
					<Button
						type="submit"
						variant="contained"
						sx={subscribeButtonSX}
						data-testid="button-subscription-submit"
						id="button-subscription-submit"
					>
						{newsLetterNLS.Labels.SubscriptionSubmit.t()}
					</Button>
				</Stack>
				<Stack sx={{paddingLeft:'68px'}}>
					<Typography variant="h2" className="sendNewsLetterSubsc">{newsLetterNLS.Labels.Extra_interests.t()}</Typography>
					<Grid container >
						<Grid item xs={12} className="adfcheckboxField">
							<FormControlLabel
								control={<Checkbox
									name="babyPeuter"
									id="WC_News_Brief_Page_Checkbox_1"
									checked={subscriptionValues.babyPeuter}
									onChange={(e) => handleChange(e,babyPeuterContactListId)} 
								/>}
								label={newsLetterNLS.Labels.BabyPeuter.t()} />
						</Grid>
						<Grid item xs={12} className="adfcheckboxField">
							<FormControlLabel
								control={<Checkbox
									name="gaming"
									id="WC_News_Brief_Page_Checkbox_2"
									checked={subscriptionValues.gaming}
									onChange={(e) => handleChange(e,gamingContactListId)} 
							/>}
								label={newsLetterNLS.Labels.Gaming.t()} />
						</Grid>
					</Grid> 
				</Stack> 
				</Stack>
		</Stack>
	);
};
